export const hideTopPanel = () => {
  const topPanel = document.body.querySelector<HTMLElement>("#__top-panel");

  if (topPanel) {
    topPanel.style.visibility = "hidden";
    topPanel.style.opacity = "0";
  }
};

export const showTopPanel = () => {
  const topPanel = document.body.querySelector<HTMLElement>("#__top-panel");

  if (topPanel) {
    topPanel.style.visibility = "visible";
    topPanel.style.opacity = "1";
  }
};
